var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericConfirmationDialog',{ref:"dialogRef",attrs:{"persistent":"","confirmHandler":_vm.confirmHandler,"max-width":"500px","titleIcon":"mdi-alert-box-outline","title":"Bankkonto verbinden","confirmButtonText":"Bankkonto jetzt erneut verbinden","bodyText":"Ihr Bankkonto muss erneut verbunden werden."}})
}
var staticRenderFns = []

export { render, staticRenderFns }